import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { Observable } from 'rxjs';
import { FooterButtonStates } from '@app/onboarding/components/onboarding-footer/onboarding-footer.model';
import { TrackerStep } from '@app/onboarding/components/tracker/tracker.component';
import { OnboardingStep } from '@app/onboarding/onboarding.enums';
import { OnboardingConfigService } from '@app/onboarding/services/onboarding-config.service';
import { OnboardingStateService } from '@app/onboarding/services/onboarding-state.service';
/**
 * Onboarding Footer Component
 * Footer of the onboarding experience. This houses the buttons and track stepper(different component)
 *
 * @param nextStep emits current step to parent when user selects next button
 * @param previousStep emits current step to parent when user selects previous button
 * @param skipStep emits current step to parent when user selects skip button
 *
 * @example
 * ```<dgx-onboarding-footer (nextStep)="nextStep($event)"
 *      (previousStep)="previousStep($event)"
 *      (skipStep)="skipStep($event)"></dgx-startlearning>```
 */
@Component({
  selector: 'dgx-onboarding-footer',
  templateUrl: './onboarding-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingFooterComponent {
  @Output() public nextStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() public previousStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() public skipStep: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public trackerEvent: EventEmitter<TrackerStep> = new EventEmitter<TrackerStep>();
  public templatePrefix: string;
  //  updateButtonStates {Observable<FooterButtonStates} Stream of the button states
  // * - previous button text (previousButton)
  // * - next button text (nextButton)
  public updateButtonStates: Observable<FooterButtonStates> =
    this.onboardingConfigService.footerButtonAction;
  //  updateTrackerStates {Observable<TrackerStep} Stream of the tracker dot states
  public updateTrackerStates: Observable<TrackerStep[]> =
    this.onboardingStateService.trackerSteps$;

  constructor(
    private onboardingConfigService: OnboardingConfigService,
    private onboardingStateService: OnboardingStateService
  ) {}

  public onPrevButton(
    currentStep: OnboardingStep,
    buttonState: FooterButtonStates
  ): void {
    this.previousStep.emit({ currentStep, buttonState });
  }

  public onSkipButton(
    currentStep: OnboardingStep,
    buttonState: FooterButtonStates
  ): void {
    this.skipStep.emit({ currentStep, buttonState });
  }

  public onNextButton(
    currentStep: OnboardingStep,
    buttonState: FooterButtonStates
  ): void {
    this.nextStep.emit({ currentStep, buttonState });
  }

  public onTrackerClicked(step: TrackerStep): void {
    this.trackerEvent.emit(step);
  }
}
